"use strict";

require("core-js/modules/es.weak-map.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DeviceGroupFilter = void 0;
require("core-js/modules/web.dom-collections.iterator.js");
require("core-js/modules/es.array.includes.js");
require("core-js/modules/es.string.includes.js");
var _react = _interopRequireWildcard(require("react"));
var _material = require("@mui/material");
var _DeviceGroupFilterModule = _interopRequireDefault(require("../styles/components/DeviceGroupFilter.module.css"));
require("../styles/variables.less");
var _Clear = _interopRequireDefault(require("@mui/icons-material/Clear"));
var _filter_btn = require("../icons/filter_btn");
var _Search = _interopRequireDefault(require("@mui/icons-material/Search"));
var _index = require("./index");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const DeviceGroupFilter = props => {
  const {
    groupList,
    activeGroup,
    handleChangeRadio
  } = props;
  const [anchorEl, setAnchorEl] = (0, _react.useState)(null);
  const open = Boolean(anchorEl);
  const handleClick = e => setAnchorEl(e.currentTarget);
  const handleClose = () => setAnchorEl(null);
  const [searchedValue, setSearchedValue] = (0, _react.useState)("");
  const [radioItems, setRadioItems] = (0, _react.useState)([]);
  const [originalItems, setOriginalItems] = (0, _react.useState)([]);
  (0, _react.useEffect)(() => {
    setRadioItems(groupList);
    setOriginalItems(groupList);
  }, [groupList]);
  const requestSearch = searchedVal => {
    setSearchedValue(searchedVal);
    const filteredItems = originalItems.filter(item => item.label.toLowerCase().includes(searchedVal.toLowerCase()));
    setRadioItems(filteredItems);
  };
  const cancelSearch = () => {
    setSearchedValue("");
    requestSearch("");
  };
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_material.Button, {
    variant: "contained",
    disableElevation: true,
    className: _DeviceGroupFilterModule.default.btn,
    onClick: handleClick,
    sx: {
      backgroundColor: "#000033",
      "&:hover": {
        background: "#000033"
      }
    }
  }, /*#__PURE__*/_react.default.createElement(_filter_btn.FilterBtnSVG, {
    stroke: "white"
  })), /*#__PURE__*/_react.default.createElement(_material.Popover, {
    id: "Device-table-filter",
    open: open,
    anchorEl: anchorEl,
    onClose: handleClose,
    anchorOrigin: {
      vertical: "bottom",
      horizontal: "right"
    },
    transformOrigin: {
      vertical: "top",
      horizontal: "right"
    },
    PaperProps: {
      style: {
        backgroundColor: "transparent",
        boxShadow: "none",
        borderRadius: 0
      }
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _DeviceGroupFilterModule.default.popover_container
  }, /*#__PURE__*/_react.default.createElement(_material.TextField, {
    id: "outlined-search",
    variant: "outlined",
    placeholder: "Search Groups..",
    type: "search",
    fullWidth: true,
    onChange: e => requestSearch(e.target.value),
    value: searchedValue,
    sx: {
      "& legend": {
        display: "none"
      },
      "& fieldset": {
        top: 0
      },
      "& .MuiOutlinedInput-root": {
        borderRadius: 0,
        background: "#FFFFFF",
        fontFamily: "var(--main-font-family) !important",
        padding: 0,
        "& fieldset": {
          border: "1px solid #C0C0CF"
        },
        "&:hover fieldset": {
          border: "1px solid #C0C0CF"
        },
        "&.Mui-focused fieldset": {
          border: "1px solid #C0C0CF"
        }
      },
      padding: "8px"
    },
    InputProps: {
      endAdornment: /*#__PURE__*/_react.default.createElement(_material.IconButton, {
        onClick: cancelSearch,
        disabled: !searchedValue
      }, searchedValue ? /*#__PURE__*/_react.default.createElement(_Clear.default, null) : /*#__PURE__*/_react.default.createElement(_Search.default, null))
    }
  }), /*#__PURE__*/_react.default.createElement(_material.Paper, {
    elevation: 0,
    style: {
      maxHeight: 287,
      overflow: "auto",
      backgroundColor: "transparent"
    }
  }, /*#__PURE__*/_react.default.createElement(_material.FormControl, {
    className: "w-100 ".concat(_DeviceGroupFilterModule.default.radio_group_container)
  }, /*#__PURE__*/_react.default.createElement(_material.RadioGroup, {
    "aria-labelledby": "demo-controlled-radio-buttons-group",
    name: "controlled-radio-buttons-group",
    value: activeGroup,
    onChange: handleChangeRadio
  }, radioItems === null || radioItems === void 0 ? void 0 : radioItems.map(radio => /*#__PURE__*/_react.default.createElement(_index.RadioItem, {
    value: radio.id,
    labelPlacement: "end",
    label: radio.label,
    type: "RadioListItem",
    key: "".concat(radio.label, "RadioListItem"),
    disabled: radio.disabled || false
  }))))))));
};
exports.DeviceGroupFilter = DeviceGroupFilter;